// AddEventRecordDialog/index.js
import { connect } from 'react-redux';

import AddEventRecordDialog from '../../components/AddEventRecordDialog';
import {
  openAddEventRecordDialogDispatch,
  handleEventInputChangeDispatch,
  submitRecordDispatch,
  removeEventRecordAttachment
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.event.newRecord.openAddEventRecordDialog,
    isSaving: state.event.newRecord.isSaving,
    record: state.event.newRecord.item,
    event: state.event.newEvent.item,
    allAttachments: state.event.newRecord.item.attachmentFiles,
    branchId: state.branch.branch.item && state.branch.branch.item.id
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onOpenAddEventRecordDialog: (open) => {
      dispatch(openAddEventRecordDialogDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handleEventInputChangeDispatch(value, inputFieldName));
    },
    submitRecord: (payload, mode, branchId) => {
      dispatch(submitRecordDispatch(payload, mode, branchId));
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeEventRecordAttachment(attachment));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEventRecordDialog);
